import React from 'react';
import Hero from '../components/Hero';
import TrustStrip from '../components/TrustStrip';
import ServiceCards from '../components/ServiceCards';
import AboutSection from '../components/AboutSection';
import StatsCounter from '../components/StatsCounter';
import ConditionsGrid from '../components/ConditionsGrid';
import FeaturedTestimonial from '../components/FeaturedTestimonial';
import UpcomingEvents from '../components/UpcomingEvents';
import EventBanner from '../components/EventBanner';
import TrainingPrograms from '../components/TrainingPrograms';
import Team from '../components/Team';
import AwardsCertificates from '../components/AwardsCertificates';
import Blog from '../components/Blog';
import VisitUs from '../components/VisitUs';
import AppointmentForm from '../components/AppointmentForm';

// Five-act narrative + background rhythm (D=dark, W=white, C=cream).
// Trust is told in ONE unbroken block (About→Stats→Testimonial→Team→Awards)
// instead of being split by events/training; events/training/blog are grouped
// as a "learn & grow" block before the closing conversion.
//   1 · Hook          Hero (D) · TrustStrip (W)
//   2 · What we do    ConditionsGrid (W) · ServiceCards (C)
//   3 · Why trust us  AboutSection (W) · StatsCounter (D) · Team (C)
//                     · FeaturedTestimonial (D) · AwardsCertificates (W)
//   4 · Learn & grow  UpcomingEvents (C) · TrainingPrograms (W) · Blog (C)
//   5 · Act & locate  VisitUs (W) · AppointmentForm (C)
// Team (cream) is deliberately placed BETWEEN the two dark sections (Stats,
// Testimonial) so they never stack into one black band. The only same-colour
// neighbours left are TrustStrip/Conditions (a thin strip above a white
// section — visually fine). If you reorder, keep neighbouring backgrounds
// different.
function HomePage() {
  return (
    <>
      <EventBanner />
      <Hero />
      <TrustStrip />
      <ConditionsGrid />
      <ServiceCards />
      <AboutSection />
      <StatsCounter />
      <Team />
      <FeaturedTestimonial />
      <AwardsCertificates />
      <UpcomingEvents />
      <TrainingPrograms />
      <Blog />
      <VisitUs />
      <AppointmentForm />
    </>
  );
}

export default HomePage;
